<template>
  <header
    class="header ff-sans"
    :class="{ 'header--active': menuActive }">
    <div class="header__top">
      <h1 class="header__top-site m-fs1">
        <router-link
          :to="'/'"
          v-if="(!back && !mobile) || mobile">
          ExLaB
        </router-link>
        <a href="#" @click="goBack()" v-if="back && !mobile">◄ Back</a>
      </h1>
      <h1 class="header__top-name m-dn">
        <router-link :to="'/'">Experimental Design Lab</router-link>
      </h1>
      <button
        v-if="mobile && !back"
        class="header__top-menu d-dn"
        @click="menuActive = !menuActive"
        v-html="menuText"></button>
      <button
        v-if="mobile && back"
        class="header__top-menu d-dn"
        @click="goBack()">(Back)</button>
    </div>
    <div
      v-if="!back"
      class="header__nav">
      <ul class="header__nav-list m-fs1">
        <li
          class="mb-2 d-dn"
          v-show="mobile">
          Experimental Design Lab
        </li>
        <li
          v-for="(route, key) in navigation"
          :key="`nav-item${key}`"
          class="header__nav-list__item">
          <router-link
            :to="route.path"
            v-html="route.name" />
        </li>
        <li class="header__nav-list__item">
          <a href="https://www.facebook.com/exxlab/" target="_blank" rel="noopener noreferrer">FB</a>
        </li>
        <li class="header__nav-list__item">
          <a href="https://vimeo.com/user101179899" target="_blank" rel="noopener noreferrer">VI</a>
        </li>
        <li class="header__nav-list__item">
          <a href="https://www.instagram.com/ex_lab/" target="_blank" rel="noopener noreferrer">IG</a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    back: Boolean
  },
  data() {
    return {
      menuText: '(Menu)',
      menuActive: ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) > 768),
      mobile: ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 769)
    }
  },
  computed: {
    navigation: function() {
      return this.$router.options.routes.filter((route) => {
        if (route.meta && route.meta.showInHeader) return true
      })
    }
  },
  watch: {
    menuActive: function(newVal) {
      this.$emit('menuActiveUpdate', newVal)
      this.menuText = newVal ? '(Close)' : '(Menu)'
    },
    '$route.path': function(newVal) {
      let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

      if (width < 769) {
        setTimeout(() => {
          this.menuActive = false
        }, 100)
      }
    }
  },
  methods: {
    goBack() {
      let slug = this.$route.path.split('/')
      if (slug[1] !== '') {
        this.$router.push(`/${slug[1]}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  width: 100%;
  z-index: 100;
  top: 0;
  left: 0;
  padding: 1rem $padding 0.5rem $padding;

  &--active {
    .header__nav {
      display:flex;
    }
    .header__nav {
      opacity:1;
      &-list {
        display:block;
      }
    }
  }
  a {
    &:hover {
      color:gray;
    }
  }
  &__top {
    display:flex;
    justify-content: space-between;
    font-size:$body;
    margin:0 0 0.25rem 0;
    &-menu {
      @include button_reset;
    }

    &-site {
      a {
        &:hover, &:active {
          color:#000 !important;
        }
      }
    }
  }
  &__nav {
    justify-content: space-between;
    align-items: center;
    transition: opacity 400ms ease-in-out 200ms;
    opacity:0;
    &-list {
      display:none;
      width:100%;
      &__item {
        margin:0 1.5rem 0 0;
        float:left;
        font-size:$body;

        &:last-child {
          // float:right;
          // margin: 0;
        }
        &:nth-child(8n), &:nth-child(9n), &:nth-child(10n) {
          float:right;
        }
        &:nth-child(8n) {
          margin:0;
        }
      }
    }
    &-note {
      display:none;
    }
  }
  @media screen and (max-width: $mobile) {
    padding: 0.5rem $padding--m 0.5rem $padding--m;
    max-width: 100vw;
    &--active {
      overflow: scroll;
      height: 100%;
      .header__nav {
        &-list {
          display:flex;
          flex-wrap: wrap;
          &__item {
            width: 100%;
            // font-size:
            &:nth-child(8n), &:nth-child(9n), &:nth-child(10n) {
              width:unset;
              margin:0;
            }
            &:nth-child(8n), &:nth-child(9n) {
              padding:0 0.75rem 0 0;
              &:after {
                content:',';
                font-size: 2.4rem;
              }
            }
            a {
              line-height: 1.33;
            }
          }
        }
      }
    }
  }
}
</style>
